import { UserRoleName } from 'domain/UserProfile';
import { InferType, mixed, number, object, string } from 'yup';

export const eventHostSchema = object({
  accountId: number().required(),
  name: string(),
  // CORE-273: blank unless the reader can edit the event, so it cannot be required.
  email: string(),
  avatarLink: string().nullable(),
  role: string().nullable(),
  // Null for a host with no role in the event's community: hosting does not require membership.
  communityRole: mixed<UserRoleName>().nullable(),
});

export type EventHostType = InferType<typeof eventHostSchema>;
